import React, { useEffect, useState, useCallback, useRef } from 'react';
import { bool, func, number, string, object, node } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';

// Components
import PopupOpenerButton from '../PopupOpenerButton/PopupOpenerButton';
import SearchIcon from '../../../components/Topbar/SearchIcon';
import { SearchBar } from '../../../components/Navbar/helpers/searchBar/search-bar';
import FilterModal from './filterModal/filterModal';
import CustomDateInput from './singleDatePicker';
import DestinationSearchBar from '../DestinationSearchBar/DestinationSearchBar';

// Assets


// Styles
import css from './SearchFiltersPrimary.module.css';

const parameterIcon = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769083051/socialbnb/containers/SearchPage/SearchFiltersPrimary/parameter.png';

const SearchFiltersPrimaryComponent = props => {
  const {
    rootClassName,
    className,
    children,
    isSecondaryFiltersOpen,
    toggleSecondaryFiltersOpen,
    selectedSecondaryFiltersCount,
    history,
    urlQueryParams,
    clearFilter,
    totalItems,
    handleFlatFilter,
    reduceFilter,
    currentFilterState,
    guestsFilter,
    validQueryParams,
    onMapIconClick,
    isSearchMapOpenOnMobile,
    setCurrentBounds,
    setCurrentFilterState,
    searchFilterIsPlain,
    onSearchButtonHover,
  } = props;

  // Extract CSS classes
  const classes = classNames(rootClassName || css.root, className);

  // State
  const [locationInput, setLocationInput] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [currentFilterFocus, setCurrentFilterFocus] = useState(null);
  const [isBrowser, setIsBrowser] = useState(false);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [focusInput, setFocusInput] = useState(false);

  const prevAddressRef = useRef();
  const prevUrlParamsRef = useRef();
  const lastClickTime = useRef(0);
  const focusTimeoutRef = useRef(null);
  const { address } = validQueryParams;

  const clearFocusAndCloseFilter = useCallback(() => {
    setFocusInput(false);
    if (currentFilterState) {
      reduceFilter();
    }

    setTimeout(() => {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    }, 0);
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }

    const searchInputs = document.querySelectorAll(
      'input[type="text"], input[type="search"], input'
    );
    searchInputs.forEach(input => {
      if (input && input.blur) {
        input.blur();
      }
    });

    setTimeout(() => {
      if (document.body && document.body.focus) {
        document.body.focus();
      }
    }, 10);
  }, [currentFilterState, reduceFilter]);

  useEffect(() => {
    const handleClickOutside = event => {
      const searchInputContainer = document.querySelector(`.${CSS.escape(css.searchInputFilterPrimary)}`);
      const filterPlain = document.querySelector('[id="filterPlain"]');
      const filterContainer = document.querySelector(`.${CSS.escape(css.filterContainer)}`);
      const mapWrapper = document.querySelector('[data-testid="searchMapContainer"]');
      const modalFilter = document.querySelector('[data-testid="modal-filter"]');
      const mainFiltersWrapper = document.querySelector(`.${CSS.escape(css.mainFiltersWrapper)}`);

      const isInsideSearch = searchInputContainer && searchInputContainer.contains(event.target);
      const isInsideFilterPlain = filterPlain && filterPlain.contains(event.target);
      const isInsideFilterContainer = filterContainer && filterContainer.contains(event.target);
      const isInsideModal = modalFilter && modalFilter.contains(event.target);
      const isInsideMainFilters = mainFiltersWrapper && mainFiltersWrapper.contains(event.target);

      const isOnMap = mapWrapper && mapWrapper.contains(event.target);

      const isOutsideAllFilters =
        !isInsideSearch &&
        !isInsideFilterPlain &&
        !isInsideFilterContainer &&
        !isInsideModal &&
        !isInsideMainFilters;

      if (isOutsideAllFilters || isOnMap) {
        clearFocusAndCloseFilter();
      }
    };

    document.addEventListener('mousedown', handleClickOutside, true);
    document.addEventListener('click', handleClickOutside, true);
    document.addEventListener('touchstart', handleClickOutside, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
      document.removeEventListener('click', handleClickOutside, true);
      document.removeEventListener('touchstart', handleClickOutside, true);
    };
  }, [clearFocusAndCloseFilter]);

  useEffect(() => {
    const handleDoubleClick = event => {
      const currentTime = Date.now();
      if (currentTime - lastClickTime.current < 300) {
        const searchInputContainer = document.querySelector(`.${CSS.escape(css.searchInputFilterPrimary)}`);
        const filterPlain = document.querySelector('[id="filterPlain"]');
        const filterContainer = document.querySelector(`.${CSS.escape(css.filterContainer)}`);
        const searchFilterItem = document.querySelector(`.${CSS.escape(css.searchFilterItem)}`);
        const mainFiltersWrapper = document.querySelector(`.${CSS.escape(css.mainFiltersWrapper)}`);

        const isInsideSearch = searchInputContainer && searchInputContainer.contains(event.target);
        const isInsideFilterPlain = filterPlain && filterPlain.contains(event.target);
        const isInsideFilterContainer = filterContainer && filterContainer.contains(event.target);
        const isInsideSearchFilterItem =
          searchFilterItem && searchFilterItem.contains(event.target);
        const isInsideMainFilters = mainFiltersWrapper && mainFiltersWrapper.contains(event.target);

        const isOnSearchElements =
          isInsideSearch ||
          isInsideFilterPlain ||
          isInsideFilterContainer ||
          isInsideSearchFilterItem ||
          isInsideMainFilters;

        if (!isOnSearchElements) {
          clearFocusAndCloseFilter();
        }
      }
      lastClickTime.current = currentTime;
    };

    document.addEventListener('click', handleDoubleClick);
    return () => {
      document.removeEventListener('click', handleDoubleClick);
    };
  }, [clearFocusAndCloseFilter]);

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        clearFocusAndCloseFilter();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [clearFocusAndCloseFilter]);

  useEffect(() => {
    if (focusInput || currentFilterState) {
      if (focusTimeoutRef.current) {
        clearTimeout(focusTimeoutRef.current);
      }

      // Increased timeout to 30 seconds to keep dropdown open longer
      // focusTimeoutRef.current = setTimeout(() => {
      //   clearFocusAndCloseFilter();
      // }, 30000);
    }

    return () => {
      if (focusTimeoutRef.current) {
        clearTimeout(focusTimeoutRef.current);
      }
    };
  }, [focusInput, currentFilterState, clearFocusAndCloseFilter]);

  useEffect(() => {
    if (
      prevAddressRef.current !== undefined &&
      prevAddressRef.current !== address &&
      address &&
      address.length > 0
    ) {
      clearFocusAndCloseFilter();
    }
    prevAddressRef.current = address;
  }, [address, clearFocusAndCloseFilter]);

  useEffect(() => {
    const currentParams = JSON.stringify({
      address: urlQueryParams.address,
      origin: urlQueryParams.origin,
      bounds: urlQueryParams.bounds,
      country: urlQueryParams.country,
    });
    const prevParams = JSON.stringify(prevUrlParamsRef.current || {});

    if (prevParams !== currentParams && prevUrlParamsRef.current !== undefined) {
      clearFocusAndCloseFilter();
    }

    prevUrlParamsRef.current = {
      address: urlQueryParams.address,
      origin: urlQueryParams.origin,
      bounds: urlQueryParams.bounds,
      country: urlQueryParams.country,
    };
  }, [
    urlQueryParams.address,
    urlQueryParams.origin,
    urlQueryParams.bounds,
    urlQueryParams.country,
    clearFocusAndCloseFilter,
  ]);

  // Effects
  useEffect(() => {
    setIsBrowser(true);
  }, []);

  useEffect(() => {
    if (isBrowser) {
      const handleResize = () => {
        setIsMobileDevice(window.innerWidth < 561);
      };

      handleResize();
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [isBrowser]);

  useEffect(() => {
    if (focusInput && isDatePickerOpen) {
      setFocusInput(false);
    }
  }, [isDatePickerOpen, focusInput]);

  // Handlers
  const handleEndDateChange = date => {
    setToDate(date);
    if (isMobileDevice) {
      setCurrentFilterFocus(null);
    }
    setIsDatePickerOpen(false);
  };

  // SVG placeholder generator
  const svgPlaceholder = (placeholder, isDate) =>
    encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="20">
      <text x="6" y="13" fill="${
        !isDate ? '#a1a1a1' : '#FFFFF'
      }" font-family="poppins, sans-serif" font-size="7px">${placeholder}</text>
    </svg>
  `);

  // UI Components
  const toggleSecondaryFiltersOpenButton = toggleSecondaryFiltersOpen ? (
    <PopupOpenerButton
      isSelected={isSecondaryFiltersOpen || selectedSecondaryFiltersCount > 0}
      toggleOpen={() => {
        toggleSecondaryFiltersOpen(!isSecondaryFiltersOpen);
      }}
    >
      <FormattedMessage
        id="SearchFiltersPrimary.moreFiltersButton"
        values={{ count: selectedSecondaryFiltersCount }}
      />
    </PopupOpenerButton>
  ) : null;

  const startDateInput = (
    <CustomDateInput
      date={fromDate}
      setDate={setFromDate}
      id="from"
      placeholder={'01.01'}
      isDatePickerOpen={isDatePickerOpen}
      setIsDatePickerOpen={setIsDatePickerOpen}
    />
  );

  const endDateInput = (
    <CustomDateInput
      date={toDate}
      setDate={handleEndDateChange}
      id="to"
      placeholder={'31.12'}
      isDatePickerOpen={isDatePickerOpen}
      setIsDatePickerOpen={setIsDatePickerOpen}
    />
  );

  // Render mobile date view
  const renderMobileDateView = () => {
    if (currentFilterFocus === 'date') {
      return (
        <div className={classes}>
          <div className={css.mainFiltersWrapper}>
            <div
              className={css.datesDisplay}
              data-elb="searchp"
              data-elb-searchp={`name:periodFilter;from-date:${fromDate};to-date:${toDate};`}
              data-elbaction="click: click datesFilter"
            >
              <div className={css.label}>
                <span className={css.filterTitle}>
                  <FormattedMessage id="SearchFiltersPrimary.datesLabel" />
                </span>
              </div>
              <div className={css.dateInputs}>
                {startDateInput}
                {endDateInput}
                <div
                  className={css.searchFilterIconMobile}
                  onClick={() => {
                    clearFocusAndCloseFilter();
                    setCurrentFilterFocus(null);
                    setIsDatePickerOpen(false);
                  }}
                >
                  <div
                    className={css.searchIconMobile}
                    data-elb="searchp"
                    data-elbaction="click: click searchIcon"
                  >
                    <SearchIcon rootClassName={css.searchIconMain} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  // Conditional rendering
  if (isSearchMapOpenOnMobile) {
    return <></>;
  }

  if (isMobileDevice && currentFilterFocus === 'date') {
    return renderMobileDateView();
  }

  return (
    <div className={classes} data-testid="filters-container">
      <div className={css.mainFiltersWrapper}>
        {!currentFilterState ? (
          <DestinationSearchBar history={history} validQueryParams={validQueryParams} />
        ) : (
          <div className={css.filterPlain} id="filterPlain">
            <div className={css.emptyclass} onMouseEnter={reduceFilter}></div>
            <div className={css.emptyclass2} onMouseEnter={reduceFilter}></div>
            <div
              className={css.searchFilterItem}
              onClick={() => {
                !isMobileDevice ? handleFlatFilter() : null;
                setFocusInput(true);
              }}
              onMouseEnter={() => onSearchButtonHover && onSearchButtonHover(true)}
              onMouseLeave={() => onSearchButtonHover && onSearchButtonHover(false)}
              data-elb="searchp"
              data-elb-searchp={`name:locationFilter;location:${address || ''};`}
              data-elbaction="click: click locationFilter"
            >
              <span>
                <FormattedMessage id="criteria_header_6" />
              </span>
              <SearchBar
                history={history}
                currentSearchParams={urlQueryParams}
                validQueryParams={validQueryParams}
                setCurrentBounds={setCurrentBounds}
                focusInput={focusInput}
                isDatePickerOpen={isDatePickerOpen}
              />
            </div>

            {/* <div>
              <span className={css.filterTitle}>
                <FormattedMessage id="SearchFiltersPrimary.datesLabel" />
              </span>
              <div className={css.dateInputs}>
                {startDateInput}
                {endDateInput}
              </div>
            </div>
            <div>{guestsFilter}</div> */}

            <div className={css.searchFilterItemPlain}>
              <div
                className={css.searchFilterPlainWrapper}
                onClick={reduceFilter}
                data-elb="searchp"
                data-elbaction="click: click searchIcon"
              >
                <div className={css.searchIconPlain}>
                  <SearchIcon rootClassName={css.searchIconMain} />
                </div>
                <span>
                  <FormattedMessage id="navbar.searchButtonText" />
                </span>
              </div>
            </div>
            <div className={css.filterButtonPlain}>
              <span className={css.results}>
                <FormattedMessage
                  id="MainPanelHeader.foundResults"
                  values={{ count: totalItems }}
                />
              </span>
              <div
                className={css.filterItemPlain}
                onClick={() => setModalOpen(true)}
                data-elb="searchp"
                data-elb-searchp={`name:moreFilter;results:${totalItems};`}
                data-elbaction="click: click moreFilter"
              >
                <img src={parameterIcon} className={css.paramIcon} />
                <span> Filter</span>
              </div>
            </div>
          </div>
        )}
      </div>
      <FilterModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        clearFilter={clearFilter}
        totalItems={totalItems}
      >
        <div className={css.filters}>
          <div
            className={css.guestsMobile}
            data-elb="searchp"
            data-elb-searchp={`name:guestsFilter;`}
            data-elbaction="click: click guestsFilter"
          >
            {guestsFilter}
          </div>
          {children}
        </div>
      </FilterModal>
    </div>
  );
};

SearchFiltersPrimaryComponent.defaultProps = {
  rootClassName: null,
  className: null,
  isSecondaryFiltersOpen: false,
  toggleSecondaryFiltersOpen: null,
  selectedSecondaryFiltersCount: 0,
  handleFlatFilter: () => {},
  reduceFilter: () => {},
  currentFilterState: false,
  onMapIconClick: () => {},
  isSearchMapOpenOnMobile: false,
  setCurrentBounds: () => {},
  setCurrentFilterState: () => {},
  onSearchButtonHover: () => {},
};

SearchFiltersPrimaryComponent.propTypes = {
  rootClassName: string,
  className: string,
  isSecondaryFiltersOpen: bool,
  toggleSecondaryFiltersOpen: func,
  selectedSecondaryFiltersCount: number,
  history: object,
  urlQueryParams: object,
  clearFilter: func,
  totalItems: number,
  handleFlatFilter: func,
  reduceFilter: func,
  currentFilterState: bool,
  guestsFilter: node,
  validQueryParams: object,
  onMapIconClick: func,
  isSearchMapOpenOnMobile: bool,
  setCurrentBounds: func,
  setCurrentFilterState: func,
  onSearchButtonHover: func,
};

const SearchFiltersPrimary = SearchFiltersPrimaryComponent;

export default SearchFiltersPrimary;
